/**
=========================================================
* Material Kit 2 React - v2.1.0
=========================================================

* Product Page: https://www.creative-tim.com/product/material-kit-react
* Copyright 2023 Creative Tim (https://www.creative-tim.com)

Coded by www.creative-tim.com

 =========================================================

* The above copyright notice and this permission notice shall be included in all copies or substantial portions of the Software.
*/
import { ApolloClient, ApolloProvider, HttpLink, InMemoryCache } from "@apollo/client";
//import { split } from "apollo-link";
//import { ApolloClient, ApolloProvider, HttpLink, InMemoryCache, split } from "@apollo/client";
//import { ApolloClient, InMemoryCache, ApolloProvider } from "@apollo/client";
import { setContext } from "apollo-link-context";
//import { setContext } from "@apollo/link-context";
//import { getMainDefinition } from "@apollo/client/utilities";
//import { WebSocketLink } from "@apollo/link-ws";
import { Provider } from "react-redux";
import ReactDOM from "react-dom";
//import configureStore from "./store";
//import * as serviceWorker from "./serviceWorker";
//import { gql } from '@apollo/client';
import React from "react";
//import * as ReactDOMClient from "react-dom/client";
import { BrowserRouter } from "react-router-dom";
import App from "App";
import { I18nextProvider } from "react-i18next";
import i18next from "i18next";
import common_en from "./translations/en/common.json";
import common_fi from "./translations/fi/common.json";
import common_sv from "./translations/sv/common.json";
//import { Provider } from "react-redux";
import configureStore from "./store";
//import * as serviceWorker from "./serviceWorker";
//import { ApolloProvider } from "@apollo/client";
//import { setContext } from "apollo-link-context";

//import { getMainDefinition } from "@apollo/client/utilities";
//import { WebSocketLink } from "@apollo/link-ws";
//import { WebSocketLink } from "apollo-link-ws";
//import { loadErrorMessages, loadDevMessages } from "@apollo/client/dev";

/*if (__DEV__) {
  // Adds messages only in a dev environment
  loadDevMessages();
  loadErrorMessages();
}*/
//const container = document.getElementById("root");

const store = configureStore();
// Create a root.
//const root = ReactDOMClient.createRoot(container);
i18next.init({
  interpolation: { escapeValue: false },
  lng: "fi",
  resources: {
    en: {
      common: common_en,
    },
    fi: {
      common: common_fi,
    },
    sv: {
      common: common_sv,
    },
  },
});

const authLink = setContext((_, { headers }) => {
  const token = localStorage.getItem("daas-user-token");
  return {
    headers: {
      ...headers,
      authorization: token ? `bearer ${token}` : null,
    },
  };
});
/*const httpLink = new HttpLink({
  uri: "http://localhost:3001/app",
  //uri: 'https://kansalaiset.herokuapp.com/app',
});
*/
const httpLink = new HttpLink({
  uri: "https://kunta.live/app",
  //uri: 'https://kansalaiset.herokuapp.com/app',
});
/*const wsLink = new WebSocketLink({
  //uri: 'wss://kansalaiset.herokuapp.com',
  uri: "wss://kunta.live",
  options: {
    reconnect: true,
  },
});
*/
/*
const splitLink = split(
  ({ query }) => {
    const definition = getMainDefinition(query);
    return definition.kind === "OperationDefinition" && definition.operation === "subscription";
  },
  wsLink,
  authLink.concat(httpLink)
);
*/
/*const splitLink = split(
  ({ query }) => {
    const definition = getMainDefinition(query);
    return definition.kind === "OperationDefinition" && definition.operation === "subscription";
  },
  authLink.concat(httpLink)
);
/*const client = new ApolloClient({
  cache: new InMemoryCache(),
  link: httpLink,
});
*/
const client = new ApolloClient({
  cache: new InMemoryCache(),
  link: authLink.concat(httpLink),
});

/*
const client = new ApolloClient({
  uri: "http://localhost:3001/app",
  cache: new InMemoryCache(),
});
*/
/*
const client = new ApolloClient({
  uri: "https://kunta.live/app",
  cache: new InMemoryCache(),
});
*/
ReactDOM.render(
  <ApolloProvider client={client}>
    <I18nextProvider i18n={i18next}>
      <React.StrictMode>
        <Provider store={store}>
          <BrowserRouter>
            <App />
          </BrowserRouter>
        </Provider>
      </React.StrictMode>
    </I18nextProvider>
  </ApolloProvider>,
  document.getElementById("root")
);
/***
 * 
 * 
 * <I18nextProvider i18n={i18next}>
    <React.StrictMode>
      <BrowserRouter>
        <App />
      </BrowserRouter>
    </React.StrictMode>
  </I18nextProvider>
 */
/**
 * 
 * root.render(
  <ApolloProvider client={client}>
    <I18nextProvider i18n={i18next}>
      <React.StrictMode>
        <Provider store={store}>
          <BrowserRouter>
            <App />
          </BrowserRouter>
        </Provider>
      </React.StrictMode>
    </I18nextProvider>
  </ApolloProvider>
);
 */
/***
 * 
 * <I18nextProvider i18n={i18next}>
    <React.StrictMode>
      <BrowserRouter>
        <App />
      </BrowserRouter>
    </React.StrictMode>
  </I18nextProvider>
 */
